import { Tabs } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CpBody01Primary } from 'components/atoms/customer-portal/typography';
import { CpApprovalsTab } from './cp-approvals-tab';
import { CpCsatTab } from './cp-csat-tab';

const Wrapper = styled.div`
  @media (min-width: 768px) {
    max-height: 518px;
    max-width: 400px;
    min-height: 518px;
    min-width: 400px;
  }

  background: var(--cp-white);
  .ant-tabs-tab,
  .ant-tabs-nav-list {
    width: 100%;
  }

  .ant-tabs-tab {
    padding-left: var(--cp-spacing-06);
  }
`;

const Title = styled(CpBody01Primary)`
  padding-top: var(--cp-spacing-06);
  padding-left: var(--cp-spacing-06);
  padding-bottom: var(--cp-spacing-03);
`;

enum TabKeys {
  Approvals = 'approvals',
  Csat = 'csat',
}

export const CpApprovalsAndCsatContent: React.FC = () => {
  return (
    <Wrapper>
      <Title>
        <FormattedMessage id="cp.approvals_and_csat.title" />
      </Title>
      <Tabs defaultActiveKey={TabKeys.Approvals}>
        <Tabs.TabPane
          tabKey={TabKeys.Approvals}
          key={TabKeys.Approvals}
          tab={<FormattedMessage id="cp.approvals_and_csat.approvals.title" />}
        >
          <CpApprovalsTab />
        </Tabs.TabPane>
        <Tabs.TabPane
          tabKey={TabKeys.Csat}
          key={TabKeys.Csat}
          tab={<FormattedMessage id="cp.approvals_and_csat.csat.title" />}
        >
          <CpCsatTab />
        </Tabs.TabPane>
      </Tabs>
    </Wrapper>
  );
};
